import {
  Component,
  OnInit,
  ViewChild,
  TemplateRef,
  Output,
  EventEmitter,
  OnChanges,
  OnDestroy,
  Input
} from '@angular/core'
import { FormGroup, FormBuilder, Validators, FormArray } from '@angular/forms'
import { BsModalRef, BsModalService } from 'ngx-bootstrap'
import { Subscription } from 'rxjs/Subscription'
import { StoreService } from 'app/service/store.service'
import { CpmService } from 'app/service/cpm.service'
import { isNullOrUndefined } from 'util'
import { ActivatedRoute } from '@angular/router'
import { ToastrService } from 'ngx-toastr'
@Component({
  selector: 'app-revenue-table',
  templateUrl: './revenue-table.component.html',
  styleUrls: ['./revenue-table.component.scss']
})
export class RevenueTableComponent implements OnInit, OnDestroy {
  @ViewChild('templateDel') templateDel: TemplateRef<any>
  @ViewChild('templateSaved') templateSaved: TemplateRef<any>
  @Output() onFinished: EventEmitter<any> = new EventEmitter()
  @Output() flagRevenueChange: EventEmitter<any> = new EventEmitter()
  modalRef: BsModalRef
  modalConfig: {
    animated: true
    keyboard: true
    backdrop: true
    ignoreBackdropClick: true
  }

  listItem = []
  listOption = []
  listHeadYear = []
  listHead = []
  otherOption
  revenueForm: FormGroup
  subscription: Subscription
  symbol
  yearF56
  fetchYear
  editFlag = false
  listDelete = []
  listAdd = []
  allYear1 = 0
  allYear2 = 0
  allYear3 = 0
  noNewF56Table = false
  message
  doneSetUpForm = false
  constructor(
    private fb: FormBuilder,
    private store: StoreService,
    private cpmService: CpmService,
    private modalService: BsModalService,
    private toastr: ToastrService,
    private activatedRoute: ActivatedRoute
  ) { }

  ngOnInit() {

    const { symbol } = this.activatedRoute.snapshot.params

    if (symbol !== undefined) {

      this.symbol = symbol

      this.cpmService.getSecurityProfile(this.symbol).then(response => {
        this.noNewF56Table = false
        this.doneSetUpForm = false
        this.listHead = []
        this.listHeadYear = []
        if (!response) {
          return
        }
        this.yearF56 = response['yearF56']
        this.symbol = symbol

        for (let i = this.yearF56 - 2; i <= this.yearF56; i++) {
          this.listHead.push(i.toString())
          this.listHeadYear.push(i.toString())
          this.listHead.push('%')
        }
    
        this.createForm()

        this.fetchYear = this.yearF56
        this.getRevenueList()

      });
    } else {

      this.subscription = this.store
        .getSecurityProfileNewResultObservable()
        .subscribe(response => {
          this.noNewF56Table = false
          this.doneSetUpForm = false
          this.listHead = []
          this.listHeadYear = []

          if (!response) {
            return
          }
          this.yearF56 = response['yearF56']
          this.symbol = response['securitySymbol']

          for (let i = this.yearF56 - 2; i <= this.yearF56; i++) {
            this.listHead.push(i.toString())
            this.listHeadYear.push(i.toString())
            this.listHead.push('%')
          }
      
          this.createForm()

          if (!isNullOrUndefined(this.symbol)) {
            this.fetchYear = this.yearF56
            this.getRevenueList()
          }
        })
    }

  }

  getRevenueList() {
    this.cpmService.getRevenueItemList().then(async item => {
      this.listOption = item
      const otherRevenue = this.listOption.find(
        x => x.description === 'รายได้อื่นๆ'
      )
      this.otherOption = otherRevenue ? otherRevenue : ''
      await this.cpmService
        .getRevenueBySecuritySymbol(this.symbol, this.fetchYear)
        .then(obj => {
          this.listItem = []
          obj.map(other => {
            this.listItem.push(other)
          })
        })
      this.rebuildForm()
    })
  }

  createForm() {
    this.revenueForm = this.fb.group({
      items: this.fb.array([])
    })
  }

  rebuildForm() {
    if (this.yearF56 - this.fetchYear <= 1  && this.listItem.length == 0) {
      this.noNewF56Table = true;
      this.fetchYear = this.fetchYear - 1;
      this.getRevenueList();
    }
    else {
      if (this.listItem.length == 0) this.fetchYear = this.yearF56;
      this.revenueForm = this.fb.group({
        items: this.fb.array([])
      })
      this.setUpForm()
      this.onCalculate()
    }
  }

  get items(): FormArray {
    return this.revenueForm.get('items') as FormArray
  }

  setUpForm() {

    const itemStart = this.listItem.filter(itemObj => itemObj.year === this.fetchYear );
    itemStart.map((opt, optIndex) => {
      const obj = new OrthetObj()
      obj.item = opt
      obj.displayFlag = false
      obj.searchInputControl = [opt.item.description, Validators.required]
      const listItemByOption = this.listItem.filter(
        objItem => objItem.item.code === opt.item.code
      )

      if (listItemByOption.length !== 0) {
        for (let i = 0; i < this.listHeadYear.length; i++) {
          const itemYear = listItemByOption.find(itemObj => itemObj.year == this.listHeadYear[i])
          obj.id = optIndex
            switch (i) {
              case 0: {
                obj.year1 = itemYear !== undefined ? itemYear.value : 0
                obj.percent_year1 = 0
                if (this.fetchYear != this.yearF56) obj.year1_id = null
                else obj.year1_id = itemYear !== undefined ? itemYear.id : null
                break
              }
              case 1: {
                obj.year2 = itemYear !== undefined ? itemYear.value : 0
                obj.percent_year2 = 0
                if (this.fetchYear != this.yearF56) obj.year2_id = null
                else obj.year2_id = itemYear !== undefined ? itemYear.id : null
                break
              }
              case 2: {
                obj.year3 = itemYear !== undefined ? itemYear.value : 0
                obj.percent_year3 = 0
                if (this.fetchYear != this.yearF56) obj.year3_id = null
                else obj.year3_id = itemYear !== undefined ? itemYear.id : null
                break
              }
            }
        }
        this.items.push(this.fb.group(obj))
      }
    })

    if (this.items.length === 0) {
      const otherObj = this.setOrthetObj('รายได้อื่นๆ')
      this.items.push(this.fb.group(otherObj))
    }

    const allObj = this.setOrthetObj('รวมรายได้')
    this.items.push(this.fb.group(allObj))

    this.doneSetUpForm = true

  }

  setEditFlag() {
    if (this.items.length === 0) {
      this.addItem()
    }
    this.editFlag = true
    this.setDisplayFlag()
  }

  addItem() {
    const obj = new OrthetObj()
    obj.id = ''
    obj.searchInputControl = ['', Validators.required]
    obj.detail = ''
    obj.securitySymbol = this.symbol

    obj.year1 = 0
    obj.percent_year1 = 0
    obj.year2 = 0
    obj.percent_year2 = 0
    obj.year3 = 0
    obj.percent_year3 = 0
    obj.item = ''
    obj.year1_id = ''
    obj.year2_id = ''
    obj.year3_id = ''

    // this.items.length - 2
    this.items.insert(this.items.length - 2, this.fb.group(obj))
    this.setDisplayFlag()
  }

  setDisplayFlag() {
    this.items.controls.map((obj, i) => {
      let display = false
      let displayFlagYear

      displayFlagYear = this.editFlag && i <= this.plusItems
      if (i === this.plusItems) {
        display = false
      } else {
        display = this.editFlag && i <= this.plusItems
      }

      obj.get('displayFlagYear').setValue(displayFlagYear)
      obj.get('displayFlag').setValue(display)
    })
  }
  get plusItems(): Number {
    return (this.items.length - 2) as Number
  }

  onDelete(index) {

    const idDelete = this.items.controls[index].get('id').value
    if (idDelete !== '') {
      this.listDelete.push(this.items.controls[index].get('year1_id').value)
      this.listDelete.push(this.items.controls[index].get('year2_id').value)
      this.listDelete.push(this.items.controls[index].get('year3_id').value)
    }

    this.listDelete = this.listDelete.filter(obj => obj !== null)

    this.items.removeAt(index)
    this.setDisplayFlag()
    this.onCalculate()
  }

  onCalculate() {
    const listYear1 = []
    const listYear2 = []
    const listYear3 = []
    this.items.controls.map((obj, i) => {
      obj.get('year1').setValue(obj.get('year1').value.toString().replace(/[^\d,.]/g, ''))
      obj.get('year2').setValue(obj.get('year2').value.toString().replace(/[^\d,.]/g, ''))
      obj.get('year3').setValue(obj.get('year3').value.toString().replace(/[^\d,.]/g, ''))
      if (i <= this.plusItems) {
        listYear1.push(obj.get('year1').value)
        listYear2.push(obj.get('year2').value)
        listYear3.push(obj.get('year3').value)
      } else {
        // tslint:disable-next-line:max-line-length
        this.allYear1 = listYear1.reduce((a, b) => Number((isNaN(a) ? a.toString().replace(/,/g, '') : a)) + Number((isNaN(b) ? b.toString().replace(/,/g, '') : b)), 0)
        // tslint:disable-next-line:max-line-length
        this.allYear2 = listYear2.reduce((a, b) => Number((isNaN(a) ? a.toString().replace(/,/g, '') : a)) + Number((isNaN(b) ? b.toString().replace(/,/g, '') : b)), 0)
        // tslint:disable-next-line:max-line-length
        this.allYear3 = listYear3.reduce((a, b) => Number((isNaN(a) ? a.toString().replace(/,/g, '') : a)) + Number((isNaN(b) ? b.toString().replace(/,/g, '') : b)), 0)

        obj.get('year1').setValue(this.allYear1)
        obj.get('year2').setValue(this.allYear2)
        obj.get('year3').setValue(this.allYear3)
      }
    })
    this.setPercentValue()
  }

  setPercentValue() {
    this.items.controls.map((obj, i) => {
      const year1 = (Number((obj.get('year1').value.toString().replace(/,/g, ''))) / this.allYear1) * 100
      const year2 = (Number((obj.get('year2').value.toString().replace(/,/g, ''))) / this.allYear2) * 100
      const year3 = (Number((obj.get('year3').value.toString().replace(/,/g, ''))) / this.allYear3) * 100
      obj.get('percent_year1').setValue(+year1)
      obj.get('percent_year2').setValue(+year2)
      obj.get('percent_year3').setValue(+year3)
      obj.get('year1').setValue(Number((obj.get('year1').value.toString().replace(/,/g, ''))).toLocaleString('en-EN'))
      obj.get('year2').setValue(Number((obj.get('year2').value.toString().replace(/,/g, ''))).toLocaleString('en-EN'))
      obj.get('year3').setValue(Number((obj.get('year3').value.toString().replace(/,/g, ''))).toLocaleString('en-EN'))
    })
  }

  onEnter(index) {
    const item = this.listOption.find(
      itemObj =>
        itemObj.description ===
        this.items.controls[index].get('searchInputControl').value
    )
    item === undefined
      ? this.items.controls[index].get('item').setValue({
        code: '',
        description: this.items.controls[index].get('searchInputControl')
          .value
      })
      : this.items.controls[index].get('item').setValue(item)
  }

  onCancel() {
    const length = this.items.length
    for (let index = 0; index < length; index++) {
      this.items.removeAt(index)
    }
    this.editFlag = false
    this.setDisplayFlag()
    this.rebuildForm()
    this.flagRevenueChange.emit(true)
  }

  async onSubmit() {
    this.listAdd = []
    if (this.revenueForm.valid) {
      this.items.controls
        .filter(obj => obj.value.searchInputControl !== 'รวมรายได้')
        .map(item => {
          let countYear = 1
          for (let i = this.yearF56 - 2; i <= this.yearF56; i++) {
            const data = {}
            switch (countYear) {
              case 1: {
                data['id'] = item.value.year1_id
                data['year'] = i
                data['item'] = {
                  code: item.value.item.code,
                  description: item.value.searchInputControl
                }
                data['value'] = Number(item.value.year1.toString().replace(/,/g, ''))
                break
              }
              case 2: {
                data['id'] = item.value.year2_id
                data['year'] = i
                data['item'] = {
                  code: item.value.item.code,
                  description: item.value.searchInputControl
                }
                data['value'] = Number(item.value.year2.toString().replace(/,/g, ''))
                break
              }
              case 3: {
                data['id'] = item.value.year3_id
                data['year'] = i
                data['item'] = {
                  code: item.value.item.code,
                  description: item.value.searchInputControl
                }
                data['value'] = Number(item.value.year3.toString().replace(/,/g, ''))
                break
              }
            }
            this.listAdd.push(data)
            countYear++
          }
        })

      const putData = {
        delete: this.listDelete,
        securitySymbol: this.symbol,
        year: this.yearF56,
        add: this.listAdd
      }

      const formData = new FormData()
      formData.append(
        'updateField',
        new Blob([JSON.stringify(putData)], { type: 'application/json' })
      )

      this.cpmService.updateRevenue(formData).subscribe(
        success => {
          this.message = success.status;
          this.message === 'OK' ? this.toastr.success('Successful') : this.toastr.error('Error ' + this.message);

          this.flagRevenueChange.emit(true);
          this.noNewF56Table = false;
          this.ngOnInit();
        },
        error => {
          this.message = 'บันทึกรายการไม่สำเร็จ'
          this.toastr.error('Error')
          this.ngOnInit()
        }
      )
    }
    this.editFlag = false
  }

  finished(response): void {
    if (response) {
      // this.setDisplayFlagOnShow();
      this.onFinished.emit(response)
    } else {
      this.onFinished.emit({ message: 'Cancel action.', status: 'WARNNING' })
    }
  }

  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(
      template,
      Object.assign({}, this.modalConfig, { class: 'modal-sm' })
    )
  }
  public goBack() {
    this.editFlag = false
    this.modalRef.hide()
    this.store.setSearchInputBehavior(this.symbol)
    this.rebuildForm()
  }

  setOrthetObj(searchInputControl) {
    const obj = new OrthetObj()
    obj.id = ''
    obj.securitySymbol = this.symbol
    obj.searchInputControl = searchInputControl
    obj.year1 = 0
    obj.percent_year1 = 0
    obj.year2 = 0
    obj.percent_year2 = 0
    obj.year3 = 0
    obj.percent_year3 = 0
    obj.year1_id = ''
    obj.year2_id = ''
    obj.year3_id = ''
    obj.item = this.otherOption
    obj.displayFlag = false

    return obj
  }

  ngOnDestroy() {
    this.listHead = []
    this.listHeadYear = []
    if (!isNullOrUndefined(this.subscription)) {
      this.subscription.unsubscribe()
    }
  }

  setDisplayFlagOnShow() {
    this.items.controls.map((obj, i) => {
      obj.get('displayFlagYear').setValue(false)
      obj.get('displayFlag').setValue(false)
    })
  }
}

export class OrthetObj {
  id: any
  detail = ''
  displayFlag = false
  securitySymbol: any

  searchInputControl: any
  displayFlagYear = false
  year1: any
  year1_id: any
  percent_year1: any
  year2: any
  year2_id: any
  percent_year2: any
  year3: any
  year3_id: any
  percent_year3: any
  item: any
}



// WEBPACK FOOTER //
// /opt/alm/jenkins/workspace/mis-cpm/mis-cpm-prod-front/src/app/securities-level/revenue-table/revenue-table.component.ts